import type { RawAnalyticsSchema } from '../types/AnalyticsSchema';
import { parseRawData } from './parseRawData';
import eventsConstants from '../../../dist/constants/events_constants.json';

export const { domains, event_names, product_areas } = eventsConstants;

const importJsonEventData = async (domains: string[]) => {
  const rawEvents = await Promise.all(
    domains.map(async (domain) => {
      const domainSlug = domain.replace(/\s+/g, '-');
      const domainData = await import(`../../../dist/json/${domainSlug}.json`);
      return domainData.default.events as RawAnalyticsSchema[];
    })
  );

  return parseRawData(rawEvents.reduce((acc, curr) => ({ ...acc, ...curr }), {}));
};


export const eventData = await importJsonEventData(domains);